// extracted by mini-css-extract-plugin
export default {"myEdge":"styles_myEdge__vwCxr"};